
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/blogs/2024-07-14-react-three-fiber-4-bvh",
      function () {
        return require("private-next-pages/blogs/2024-07-14-react-three-fiber-4-bvh/index.page.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/blogs/2024-07-14-react-three-fiber-4-bvh"])
      });
    }
  